import { useRef, useCallback, useEffect } from 'react';
import subscribe from '../operations/subscribe';
import unsubscribe from '../operations/unsubscribe';
import eventTypes from '../constants/event-types';

const AUTOMATION_COMPLETION_TIMEOUT = 1000;

const useWaitForAutomation = (timeout = AUTOMATION_COMPLETION_TIMEOUT) => {
  const pendingHandlerRef = useRef(null);
  const pendingTimeoutRef = useRef(null);

  const cancel = useCallback(() => {
    if (pendingTimeoutRef.current) {
      clearTimeout(pendingTimeoutRef.current);
      pendingTimeoutRef.current = null;
    }

    if (pendingHandlerRef.current) {
      unsubscribe(eventTypes.AUTOMATION_COMPLETED, pendingHandlerRef.current);
      pendingHandlerRef.current = null;
    }
  }, []);

  const waitThen = useCallback(
    (callback) => {
      cancel();

      const onCompleted = () => {
        cancel();
        requestAnimationFrame(callback);
      };

      pendingHandlerRef.current = onCompleted;
      subscribe(eventTypes.AUTOMATION_COMPLETED, onCompleted);
      pendingTimeoutRef.current = setTimeout(onCompleted, timeout);
    },
    [cancel, timeout]
  );

  useEffect(() => () => cancel(), [cancel]);

  return waitThen;
};

export default useWaitForAutomation;
